import React from 'react';
import styles from './BackgroundShadow.module.css';
import ellipse13 from './images/img_ellipse_13.png';
import ellipse15 from './images/img_ellipse_15.png';
import ellipse18 from './images/img_ellipse_18.png';
import ellipse19 from './images/img_ellipse_19.png';

const BackgroundShadow: React.FC = () => {
    return (
        <div className={styles.backgroundShadow}>
            <img src={ellipse13} alt="" className={styles.ellipse13Img} />
            <img src={ellipse15} alt="" className={styles.ellipse15Img} />

            <div className={styles.bgEllipse18}>
                <img src={ellipse18} alt="" className={styles.ellipse18Img} />
            </div>
            <div className={styles.bgEllipse19}>
                <img src={ellipse19} alt="" className={styles.ellipse19Img} />
            </div>

            <div className={styles.circle1}></div>
            <div className={styles.circle2}></div>
            <div className={styles.circle3}></div>
        </div>
    );
};

export default BackgroundShadow;
